import { render, staticRenderFns } from "./PaymentFormCVSResult.vue?vue&type=template&id=3af9d707&scoped=true&lang=pug&"
import script from "./PaymentFormCVSResult.vue?vue&type=script&lang=js&"
export * from "./PaymentFormCVSResult.vue?vue&type=script&lang=js&"
import style0 from "./PaymentFormCVSResult.scss?vue&type=style&index=0&id=3af9d707&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af9d707",
  null
  
)

export default component.exports